const DONE_NOTE = "Completed successfully.";

function normalizeLabel(label = "") {
  return String(label || "").trim();
}

function compactText(value = "", limit = 90) {
  const text = String(value || "").replace(/\s+/g, " ").trim();
  if (text.length <= limit) return text;
  return `${text.slice(0, Math.max(0, limit - 3)).trimEnd()}...`;
}

function parseResearchLabel(rawLabel = "") {
  const match = rawLabel.match(/^(Searched (?:the web|academic papers))\s+[—-]\s+[“"]?(.+?)[”"]?\s+[—-]\s+(.+)$/i);
  if (!match) return null;
  return {
    label: match[1],
    query: match[2].trim(),
    result: match[3].trim(),
  };
}

function normalizePhase(phase = "") {
  const value = String(phase || "").trim();
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

export function getRunStepDisplay(step = {}) {
  const rawLabel = normalizeLabel(step.label);
  const text = rawLabel.toLowerCase();

  const research = parseResearchLabel(rawLabel);
  if (research) {
    return {
      label: research.label,
      note: step.note || `Query: ${compactText(research.query)} - ${research.result}`,
      phase: "Research",
      tone: "research",
      v2: true,
    };
  }

  const metadataPhase = normalizePhase(step.phase);
  if (metadataPhase) {
    return {
      label: rawLabel,
      note: step.note || "",
      phase: metadataPhase,
      tone: metadataPhase.toLowerCase(),
      v2: true,
    };
  }

  if (text.includes("built content plan")) {
    return {
      label: rawLabel,
      note: step.note || "Prompt breakdown locked.",
      phase: "Plan",
      tone: "plan",
      v2: true,
    };
  }

  if (text.includes("drafted from content plan")) {
    return {
      label: rawLabel,
      note: step.note || "Generated from the content plan.",
      phase: "Draft",
      tone: "draft",
      v2: true,
    };
  }

  if (text.includes("validated structure - repaired")) {
    return {
      label: rawLabel.replace("Validated structure - repaired", "Format check - adjusted"),
      note: step.note || "Adjusted the draft so it matched the format you asked for.",
      phase: "Quality",
      tone: "quality",
      v2: true,
    };
  }

  if (text.includes("format check - adjusted")) {
    return {
      label: rawLabel,
      note: step.note || "Adjusted the draft so it matched the format you asked for.",
      phase: "Quality",
      tone: "quality",
      v2: true,
    };
  }

  if (text.includes("structure repair")) {
    return {
      label: "Format alignment check",
      note: step.note || "Adjusted the draft so it matched the format you asked for.",
      phase: "Quality",
      tone: "quality",
      v2: true,
    };
  }

  if (text.includes("format check - passed")) {
    return {
      label: rawLabel,
      note: step.note || "Requested format verified.",
      phase: "Quality",
      tone: "quality",
      v2: true,
    };
  }

  if (text.includes("format check - needs review")) {
    return {
      label: rawLabel,
      note: step.note || "The draft may need a manual format pass.",
      phase: "Quality",
      tone: "quality",
      v2: true,
    };
  }

  if (text.includes("validated structure - passed")) {
    return {
      label: "Format check - passed",
      note: step.note || "Requested format verified.",
      phase: "Quality",
      tone: "quality",
      v2: true,
    };
  }

  if (text.includes("validated structure")) {
    return {
      label: rawLabel.replace("Validated structure", "Format check"),
      note: step.note || "Checked against the format you asked for.",
      phase: "Quality",
      tone: "quality",
      v2: true,
    };
  }

  return {
    label: rawLabel,
    note: step.note || "",
    phase: "",
    tone: "",
    v2: false,
  };
}

export function runStepStatusNote(status) {
  if (status === "done") return DONE_NOTE;
  if (status === "running") return "Currently in progress.";
  if (status === "failed") return "Stopped on this step.";
  if (status === "warning") return "Completed with a note.";
  if (status === "skipped") return "Skipped by configuration.";
  return "Waiting for prior phases.";
}
